export enum TipoAtividade {
  download = 'download',
  upload = 'upload',
}
